import { render, staticRenderFns } from "./BillingAndDeliveryAddresses.vue?vue&type=template&id=028c63e1&scoped=true"
import script from "./BillingAndDeliveryAddresses.vue?vue&type=script&lang=ts"
export * from "./BillingAndDeliveryAddresses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c63e1",
  null
  
)

export default component.exports